var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Splash',{attrs:{"content":`Welcome to Film ID. Try searching for something.`}})
}
var staticRenderFns = []

export { render, staticRenderFns }